import { getToken, getUserData } from '@/utils/auth'

export default {
  accessToken: getToken(),
  userData: getUserData(),
}
